import { MouseEvent, useEffect, useState } from 'react';
import type { CtaButtonProps } from '@/components/landing-page/components/cta-button';
import { ChevronRight } from 'lucide-react';
import clsx from 'clsx';
import { defaults } from '@/components/landing-page/components/cta-button';
import { goToSosOvmOrShowPriceDialog } from '@/components/landing-page/components/cta-button/cta-buttons.utils';
import { useAppSelector } from '@/redux/store';
import { ConfigSlice } from '@/redux/config';
import { SliderSlice } from '@/redux/slider';
import { cn } from '@/utils/helper';
import v1 from '@/components/landing-page/components/cta-button/cta-button-v1.module.css';
import v2 from '@/components/landing-page/components/cta-button/cta-button-v2.module.css';

const CtaButton = (props: CtaButtonProps) => {
  const {
    text = defaults.text,
    className = defaults.className,
    optimizely = defaults.optimizely,
    disabled = defaults.disabled,
    fullWidth = defaults.fullWidth,
  } = props;
  const [ctaButton, setCtaButton] = useState<string>('');
  const showPriceModalInsuranceCondition = useAppSelector(ConfigSlice.selectors.showPriceModalInsuranceCondition);
  const cssVersion = useAppSelector(ConfigSlice.selectors.cssVersion);
  const mappedAnswers = useAppSelector(SliderSlice.selectors.mappedAnswers);

  const onClick = (e: MouseEvent<HTMLButtonElement>): void => {
    e.preventDefault();
    e.currentTarget.blur();
    goToSosOvmOrShowPriceDialog();
  };

  useEffect(() => {
    if (showPriceModalInsuranceCondition) {
      const legalInsurance = mappedAnswers['legal_insurance'] ? mappedAnswers['legal_insurance'].value : '';
      const legalInsuranceValues = Object.keys(showPriceModalInsuranceCondition);
      setCtaButton(legalInsuranceValues.includes(legalInsurance) ? 'Preis ansehen' : 'Vollmacht ansehen');
    }
  }, [mappedAnswers, showPriceModalInsuranceCondition]);

  return (
    <button
      type='button'
      data-opti={optimizely}
      data-testid='cta-button'
      disabled={disabled}
      className={clsx(cn(v1.CtaButton, v2.CtaButton), className, {
        [cn(v1.CtaButtonFullWidth, v2.CtaButtonFullWidth)]: fullWidth,
      })}
      onClick={onClick}
    >
      <span>{props.text ? text : ctaButton}</span>
      {cssVersion === 1 ? <ChevronRight strokeWidth={3} className={cn(v1.Icon, v2.Icon)} /> : null}
    </button>
  );
};

export default CtaButton;
